import LegalLayout from "@/components/LegalLayout";
import { Mail, MapPin, Clock, Building2 } from "lucide-react";

export default function ContactUs() {
  return (
    <LegalLayout
      title="Contact Us"
      lastUpdated="June 1, 2026"
      testId="page-contact"
      noIndex
    >
      <p>
        We'd love to hear from you — whether it's a question about your atelier's workflow, a
        feature request, a partnership idea, or simply feedback on a render. Reach out using
        any of the channels below and we'll get back within one business day.
      </p>

      <div className="grid sm:grid-cols-2 gap-4 mt-8 not-prose">
        <div className="rounded-2xl border border-white/8 bg-[#0E0E0E] p-5">
          <Mail className="w-5 h-5 text-[#D4AF37] mb-3" />
          <div className="text-[10px] uppercase tracking-[0.22em] text-white/40 mb-1">Email — General</div>
          <a
            href="mailto:hello@facetra.studio"
            data-testid="contact-email-general"
            className="text-sm text-white hover:text-[#D4AF37] transition"
          >
            hello@facetra.studio
          </a>
          <p className="text-xs text-white/45 mt-2">Product, demos, partnerships, press.</p>
        </div>

        <div className="rounded-2xl border border-white/8 bg-[#0E0E0E] p-5">
          <Mail className="w-5 h-5 text-[#D4AF37] mb-3" />
          <div className="text-[10px] uppercase tracking-[0.22em] text-white/40 mb-1">Email — Support &amp; Refunds</div>
          <a
            href="mailto:hello@facetra.studio"
            data-testid="contact-email-support"
            className="text-sm text-white hover:text-[#D4AF37] transition"
          >
            hello@facetra.studio
          </a>
          <p className="text-xs text-white/45 mt-2">Billing questions, refund requests, technical issues.</p>
        </div>

        <div className="rounded-2xl border border-white/8 bg-[#0E0E0E] p-5">
          <Mail className="w-5 h-5 text-[#D4AF37] mb-3" />
          <div className="text-[10px] uppercase tracking-[0.22em] text-white/40 mb-1">Email — Privacy &amp; Data Requests</div>
          <a
            href="mailto:privacy@facetra.studio"
            data-testid="contact-email-privacy"
            className="text-sm text-white hover:text-[#D4AF37] transition"
          >
            privacy@facetra.studio
          </a>
          <p className="text-xs text-white/45 mt-2">DPDP / GDPR access, deletion, correction requests.</p>
        </div>

        <div className="rounded-2xl border border-white/8 bg-[#0E0E0E] p-5">
          <Clock className="w-5 h-5 text-[#D4AF37] mb-3" />
          <div className="text-[10px] uppercase tracking-[0.22em] text-white/40 mb-1">Hours</div>
          <p className="text-sm text-white">Monday – Friday</p>
          <p className="text-xs text-white/45 mt-1">10:00 – 18:00 IST (UTC+05:30)</p>
        </div>
      </div>

      <h2>Registered Office</h2>
      <div className="rounded-2xl border border-white/8 bg-[#0E0E0E] p-5 not-prose mt-4">
        <Building2 className="w-5 h-5 text-[#D4AF37] mb-3" />
        <p className="text-sm text-white font-medium">Facetra Design Studio Private Limited</p>
        <p className="text-xs text-white/55 mt-2 flex items-start gap-1.5">
          <MapPin className="w-3.5 h-3.5 mt-0.5 flex-shrink-0" />
          <span>Amravati, Maharashtra, India</span>
        </p>
        <p className="text-[11px] text-white/35 mt-3">
          GSTIN, CIN and other corporate details available on request for invoicing purposes.
        </p>
      </div>

      <h2>Demo Booking</h2>
      <p>
        Prefer a guided walkthrough? Book a 15-minute demo from the{" "}
        <a href="/#talk-to-us">Talk to us section</a> on our homepage — pick a date, time slot, and
        we&apos;ll send you a calendar invite plus the prep notes for your atelier.
      </p>

      <h2>For Press</h2>
      <p>
        Media kit, founder bios, and high-resolution screenshots are available on request.
        Email <a href="mailto:hello@facetra.studio">hello@facetra.studio</a> with subject{" "}
        <strong>"Press"</strong> and we'll share the press pack within 24 hours.
      </p>

      <h2>For Educational Institutions</h2>
      <p>
        Design schools (NIFT, Pearl Academy, JD Institute, IIAD, GIA campuses, etc.) can
        contact us for classroom licensing — one shared credit pool covers the whole
        cohort at bulk pricing. Email us with your institution&apos;s name, department, and
        expected student count and we&apos;ll send a quote.
      </p>
    </LegalLayout>
  );
}
